import React, { useRef, useState } from 'react'
import './main.css'
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";


// import required modules
import { Pagination, Navigation } from "swiper";

import Burglary0 from '../../images/Window Accessories/Burglary Protection/Burglary0.png';
import Burglary1 from '../../images/Window Accessories/Burglary Protection/Burglary1.png';
import Burglary2 from '../../images/Window Accessories/Burglary Protection/Burglary2.png';
import Burglary3 from '../../images/Window Accessories/Burglary Protection/Burglary3.png';
import Burglary4 from '../../images/Window Accessories/Burglary Protection/Burglary4.png';
import Burglary5 from '../../images/Window Accessories/Burglary Protection/Burglary5.png';

import Window from '../../images/Window Accessories/window.png'

export default function WindowAccessories() {
    return (
        <>
            <div className="window-accessories">
                <div className="theme-title"></div>
                <h1 className="title">Комплектующие окна</h1>
                <div className="accessories-navbar-menu">
                    <ul>
                        <li>
                            <a href="#">Фурнитура</a>
                        </li>
                        <li>
                            <a href="#">Стеклопакет</a>
                        </li>
                        <li>
                            <a href="#">Подоконник</a>
                        </li>
                        <li>
                            <a href="#">Ламинация</a>
                        </li>
                    </ul>
                </div>
                <div className="thero-one"></div>
                <div className="german-fittings">
                    <div className="german-fittings-box-left">
                        <Swiper
                            pagination={{
                                type: "fraction",
                            }}
                            navigation={true}
                            modules={[Pagination, Navigation]}
                        >
                            <SwiperSlide>
                                <div className="german-fittings-box-left-title">
                                    <h1>Немецкая фурнитура</h1>
                                </div>
                                <div className="german-fittings-box-burglary-protection">
                                    <img src={Burglary0} alt="error" />
                                    <h3>Защита от взлома</h3>
                                </div>
                                <div className="german-fittings-box-paragraph">
                                    <p>Отличное решение для тех, кто живет на нижних этажах. Инновационая система защиты гарантированно обеспечит безопасность вашей квартиры от взлома и прониковения.</p>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className="german-fittings-box-left-title">
                                    <h1>Немецкая фурнитура</h1>
                                </div>
                                <div className="german-fittings-box-burglary-protection">
                                    <img src={Burglary1} alt="error" />
                                    <h3>Детский замок</h3>
                                </div>
                                <div className="german-fittings-box-paragraph">
                                    <p>Простая и надежная защита для ваших детей. С таким замком вы можете быть уверены, что ребенок никак самостоятельно не откроет окно.</p>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className="german-fittings-box-left-title">
                                    <h1>Немецкая фурнитура</h1>
                                </div>
                                <div className="german-fittings-box-burglary-protection">
                                    <img src={Burglary2} alt="error" />
                                    <h3>Ручки для окон</h3>
                                </div>
                                <div className="german-fittings-box-paragraph">
                                    <p>Прочные пластиковые ручки с возможностью выбора любого варианта ламинации, подходящего под цвет окна и дизайн вашего интерьера.</p>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className="german-fittings-box-left-title">
                                    <h1>Немецкая фурнитура</h1>
                                </div>
                                <div className="german-fittings-box-burglary-protection">
                                    <img src={Burglary3} alt="error" />
                                    <h3>Поворотно-откидные механизмы</h3>
                                </div>
                                <div className="german-fittings-box-paragraph">
                                    <p>Удобная система, позволяющая по-разному открывать створку окна. Предусмотрено переключение на летний и зимний режимы работы.
                                    </p>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className="german-fittings-box-left-title">
                                    <h1>Немецкая фурнитура</h1>
                                </div>
                                <div className="german-fittings-box-burglary-protection">
                                    <img src={Burglary4} alt="error" />
                                    <h3>Оконные петли</h3>
                                </div>
                                <div className="german-fittings-box-paragraph">
                                    <p>Сделаны из нержавеющего материала и могут применяться в помещениях повышенной влажности. Специальная технология, которая исключает скрип при открытии и закрытии окна.</p>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className="german-fittings-box-left-title">
                                    <h1>Немецкая фурнитура</h1>
                                </div>
                                <div className="german-fittings-box-burglary-protection">
                                    <img src={Burglary5} alt="error" />
                                    <h3>Оконный уплотнитель</h3>
                                </div>
                                <div className="german-fittings-box-paragraph">
                                    <p>Обеспечивает защиту от внешнего шума и повышает теплоизоляционные свойства окна.</p>
                                </div>
                            </SwiperSlide>
                        </Swiper>
                    </div>
                    <div className="german-fittings-box-right">
                        <div className="one circle">1</div>
                        <div className="two circle">2</div>
                        <div className="three circle">3</div>
                        <div className="four circle">4</div>
                        <div className="five circle">5</div>
                        <div className="six circle">6</div>
                        <img src={Window} alt="error" />
                    </div>
                </div>
                <div className="deco"></div>
            </div>
        </>
    )
}
